import { createStore } from 'vuex'
import state from './state'
import mutations from './mutations'
export default createStore({
  state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')):state,
  mutations,
})
